// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* email row */
.InvoiceTemplateRow_invoice_template_row_root__9JCfD {
  margin-top: 10px;
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: var(--color-bg-caselist-item);
  border: 2px solid var(--color-bg-caselist-item);
}

.InvoiceTemplateRow_invoice_template_row_root__9JCfD:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 2px solid var(--color-bg-caselist-item-hover);
}

.InvoiceTemplateRow_root_inactive__rC7zY {
  background-color: var(--color-bg-caselist-item);
  border: 1px solid var(--color-theme-bright-gray);
}

.InvoiceTemplateRow_root_active__vs18f {
  background-color: var(--color-bg-caselist-item-hover);
  border: 2px solid var(--color-bg-caselist-item-hover);
  box-shadow: 2px 2px 3px var(--color-theme-cloud);
}

.InvoiceTemplateRow_edit_icon_container__naMFg {
  display: flex;
  justify-content: flex-end;
}

.InvoiceTemplateRow_edit_icon__PRee8 {
  padding: 0px 10px;
}

.InvoiceTemplateRow_edit_icon__PRee8:hover {
  color: var(--color-font-10);
}

.InvoiceTemplateRow_input_container__WqMSA {
  width: 65%;
  margin-left: 30px;
}

.InvoiceTemplateRow_template_list_item__4kfDV {
  padding: 0px !important;
}

.InvoiceTemplateRow_invoice_template_row_root__9JCfD:hover .InvoiceTemplateRow_edit_icon__PRee8 {
  color: var(--color-font-10);
}

/* submenu */
.InvoiceTemplateRow_template_row_root__YvUZa {
  display: flex;
  color: var(--color-theme-10);

  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: var(--color-bg-caselist-item);
  border: 2px solid var(--color-bg-caselist-item);
}

.InvoiceTemplateRow_template_row_root__YvUZa:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 2px solid var(--color-bg-caselist-item-hover);
  color: var(--color-font-10) !important;
}

.InvoiceTemplateRow_template_row_root_selected__fl\\+Vs {
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;
  background-color: var(--color-bg-caselist-item-selected);
  border: 2px solid var(--color-bg-caselist-item-selected);
}

.InvoiceTemplateRow_drop_down__VSjAc {
  z-index: 8000;
}

.InvoiceTemplateRow_status_item__euBb1 {
  height: 45px;
  font-size: 12px;
}

.InvoiceTemplateRow_status_icon__l3wSh {
  margin: 0px 10px 0px 15px;
}

.InvoiceTemplateRow_status_icon__l3wSh svg {
  font-size: 20px !important;
}

.InvoiceTemplateRow_status_title__H3mt3 {
  font-size: 13px;
  display: inline-block;
  height: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.InvoiceTemplateRow_delete_template__\\+0Dp\\+ {
  width: 100%;
  display: none;
  justify-content: flex-end;
  color: var(--color-theme-cloud);
}

.InvoiceTemplateRow_add_template_title__LzQML {
  color: var(--color-theme-silver);
}

.InvoiceTemplateRow_add_template_icon__-eowM {
  color: var(--color-theme-silver);
}

.InvoiceTemplateRow_template_row_root__YvUZa:hover .InvoiceTemplateRow_add_template_icon__-eowM {
  color: var(--color-font-10);
}

.InvoiceTemplateRow_template_row_root__YvUZa:hover .InvoiceTemplateRow_add_template_title__LzQML {
  color: var(--color-font-10);
}

.InvoiceTemplateRow_template_row_root__YvUZa:hover .InvoiceTemplateRow_delete_template__\\+0Dp\\+ {
  display: flex;
  color: var(--color-theme-cloud);
}

.InvoiceTemplateRow_template_row_root_selected__fl\\+Vs .InvoiceTemplateRow_delete_template__\\+0Dp\\+ {
  display: flex;
  color: var(--color-theme-cloud);
}

.InvoiceTemplateRow_delete_icon__yUcCY:hover {
  color: var(--color-theme-blue);
}

.InvoiceTemplateRow_deletionPopupText__c6dVC {
  padding: 5px;
}

.InvoiceTemplateRow_button_confirm__6Tl4r {
  font-weight: bold !important;
  width: 100px;
  margin-left: 15px !important;
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
}

.InvoiceTemplateRow_button_create__YD7lR {
  width: 200px;
  margin-left: 15px !important;
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
}

.InvoiceTemplateRow_deletionPopupButtonContainer__0z4zS {
  display: flex;
  margin-top: 36px;
  flex-direction: row-reverse;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/InvoiceTemplateRow/InvoiceTemplateRow.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;;EAEZ,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,4BAA4B;;EAE5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;;EAEZ,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,wDAAwD;EACxD,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;EACxC,mDAAmD;EACnD,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;EACxC,mDAAmD;EACnD,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B","sourcesContent":["/* email row */\n.invoice_template_row_root {\n  margin-top: 10px;\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n\n  background-color: var(--color-bg-caselist-item);\n  border: 2px solid var(--color-bg-caselist-item);\n}\n\n.invoice_template_row_root:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 2px solid var(--color-bg-caselist-item-hover);\n}\n\n.root_inactive {\n  background-color: var(--color-bg-caselist-item);\n  border: 1px solid var(--color-theme-bright-gray);\n}\n\n.root_active {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 2px solid var(--color-bg-caselist-item-hover);\n  box-shadow: 2px 2px 3px var(--color-theme-cloud);\n}\n\n.edit_icon_container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.edit_icon {\n  padding: 0px 10px;\n}\n\n.edit_icon:hover {\n  color: var(--color-font-10);\n}\n\n.input_container {\n  width: 65%;\n  margin-left: 30px;\n}\n\n.template_list_item {\n  padding: 0px !important;\n}\n\n.invoice_template_row_root:hover .edit_icon {\n  color: var(--color-font-10);\n}\n\n/* submenu */\n.template_row_root {\n  display: flex;\n  color: var(--color-theme-10);\n\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n\n  background-color: var(--color-bg-caselist-item);\n  border: 2px solid var(--color-bg-caselist-item);\n}\n\n.template_row_root:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 2px solid var(--color-bg-caselist-item-hover);\n  color: var(--color-font-10) !important;\n}\n\n.template_row_root_selected {\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n  background-color: var(--color-bg-caselist-item-selected);\n  border: 2px solid var(--color-bg-caselist-item-selected);\n}\n\n.drop_down {\n  z-index: 8000;\n}\n\n.status_item {\n  height: 45px;\n  font-size: 12px;\n}\n\n.status_icon {\n  margin: 0px 10px 0px 15px;\n}\n\n.status_icon svg {\n  font-size: 20px !important;\n}\n\n.status_title {\n  font-size: 13px;\n  display: inline-block;\n  height: 18px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.delete_template {\n  width: 100%;\n  display: none;\n  justify-content: flex-end;\n  color: var(--color-theme-cloud);\n}\n\n.add_template_title {\n  color: var(--color-theme-silver);\n}\n\n.add_template_icon {\n  color: var(--color-theme-silver);\n}\n\n.template_row_root:hover .add_template_icon {\n  color: var(--color-font-10);\n}\n\n.template_row_root:hover .add_template_title {\n  color: var(--color-font-10);\n}\n\n.template_row_root:hover .delete_template {\n  display: flex;\n  color: var(--color-theme-cloud);\n}\n\n.template_row_root_selected .delete_template {\n  display: flex;\n  color: var(--color-theme-cloud);\n}\n\n.delete_icon:hover {\n  color: var(--color-theme-blue);\n}\n\n.deletionPopupText {\n  padding: 5px;\n}\n\n.button_confirm {\n  font-weight: bold !important;\n  width: 100px;\n  margin-left: 15px !important;\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n}\n\n.button_create {\n  width: 200px;\n  margin-left: 15px !important;\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n}\n\n.deletionPopupButtonContainer {\n  display: flex;\n  margin-top: 36px;\n  flex-direction: row-reverse;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"invoice_template_row_root": `InvoiceTemplateRow_invoice_template_row_root__9JCfD`,
	"root_inactive": `InvoiceTemplateRow_root_inactive__rC7zY`,
	"root_active": `InvoiceTemplateRow_root_active__vs18f`,
	"edit_icon_container": `InvoiceTemplateRow_edit_icon_container__naMFg`,
	"edit_icon": `InvoiceTemplateRow_edit_icon__PRee8`,
	"input_container": `InvoiceTemplateRow_input_container__WqMSA`,
	"template_list_item": `InvoiceTemplateRow_template_list_item__4kfDV`,
	"template_row_root": `InvoiceTemplateRow_template_row_root__YvUZa`,
	"template_row_root_selected": `InvoiceTemplateRow_template_row_root_selected__fl+Vs`,
	"drop_down": `InvoiceTemplateRow_drop_down__VSjAc`,
	"status_item": `InvoiceTemplateRow_status_item__euBb1`,
	"status_icon": `InvoiceTemplateRow_status_icon__l3wSh`,
	"status_title": `InvoiceTemplateRow_status_title__H3mt3`,
	"delete_template": `InvoiceTemplateRow_delete_template__+0Dp+`,
	"add_template_title": `InvoiceTemplateRow_add_template_title__LzQML`,
	"add_template_icon": `InvoiceTemplateRow_add_template_icon__-eowM`,
	"delete_icon": `InvoiceTemplateRow_delete_icon__yUcCY`,
	"deletionPopupText": `InvoiceTemplateRow_deletionPopupText__c6dVC`,
	"button_confirm": `InvoiceTemplateRow_button_confirm__6Tl4r`,
	"button_create": `InvoiceTemplateRow_button_create__YD7lR`,
	"deletionPopupButtonContainer": `InvoiceTemplateRow_deletionPopupButtonContainer__0z4zS`
};
export default ___CSS_LOADER_EXPORT___;
